<template>
    <v-dialog persistent v-model="dialog" max-width="500">
        <v-card>
            <v-card-title>

                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <must-configure-branch-offices :back-button="true"/>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>

    import {mapState} from 'vuex'

    import MustConfigureBranchOffices from "./MustConfigureBranchOffices";
    export default {
        components: {MustConfigureBranchOffices},
        data(){
            return {
                dialog: false
            }
        },
        mounted(){
            const vm = this
            if(!vm.officesAreSet){
                vm.dialog = true
            }
        },
        computed:{
            ...mapState(['currentProvider']),
            officesAreSet(){
                const vm = this

                if(!vm.currentProvider) return false
                if(!vm.currentProvider.institution) return true

                return vm.currentProvider.institution.branch_offices
                    && vm.currentProvider.institution.branch_offices.length > 0
            }
        }
    }
</script>

<style scoped>

</style>